var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-section"},[_c('h1',[_vm._v("DeviceCardListSummary")]),_c('section',{staticClass:"cards-list"},_vm._l((_vm.packageList),function(pckg,i){return _c('device-card-list-summary',{key:i,attrs:{"adPlays":pckg.adPlays,"impressions":pckg.impressions,"inventory":pckg.inventory,"specs":pckg.specs}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }